<template>
  <main>
    <div id="modal1" class="modal">
      <div class="modal-content">
        <h4>Detalle de Portabilidad</h4>
        <table v-if="detail">
          <thead>
            <tr>
              <th>Telefono A Portar</th>
              <th>Telefono Destino</th>
              <th>Fecha de Creacion</th>
              <th>Fecha de Modificacion</th>
              <th>Ref. Externa</th>
              <th>Estado</th>
              <th>Comentarios</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="telephone in detail.detailList.telephone">
              <td>{{ telephone.telefonoAPortar }}</td>
              <td>{{ telephone.telefonoDestino }}</td>
              <td>{{ telephone.fechaCrea }}</td>
              <td>{{ telephone.fechaModifica }}</td>
              <td>{{ telephone.refExterna1 }}</td>
              <td>{{ telephone.estado }}</td>
              <td>{{ telephone.comentarios }}</td>
            </tr>
          </tbody>
        </table>
        <div v-else>
          <div class="row">
            <div class="col s1 offset-s5">
              <div style="margin-left: 3rem">
                <div class="preloader-wrapper big active">
                  <div class="spinner-layer spinner-blue-only">
                    <div class="circle-clipper left">
                      <div class="circle"></div>
                    </div>
                    <div class="gap-patch">
                      <div class="circle"></div>
                    </div>
                    <div class="circle-clipper right">
                      <div class="circle"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col s8 offset-s2">
              <h5>
                Espere un momento, recuperando información del servidor de ATT
              </h5>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <a href="#!" class="modal-close waves-effect waves-green btn-flat"
          >ok</a
        >
      </div>
    </div>

    <div class="contenedor-principal">
      <div class="row" >
        <div class="col s12 l10 offset-l1 card-panel recargas">
          <div class="row center-align" style="margin-bottom: 0%;">
            <div class="page-title">
              <span>Portabilidades</span>
            </div>
            <div>
              <div class=" page-title">{{ computedList.length }} registros</div>
            </div>
            <div class="row center-align" style="margin-bottom: 0%;">
              <div class="col s6 m3 offset-m3 l2 offset-l4 input-date" style="cursor: pointer;">
                <link
                  rel="stylesheet"
                  href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
                />
                <div class="center-align" @click="dateIni">
                  <span
                    class="material-symbols-outlined btn-style color"
                    style="position: relative; top: 4px;"
                    >today</span
                  >
                  <span
                    class="prefix"
                    style="font-size: 18px; width: 6rem; top: 0.2rem;"
                    >Fecha Inicial:</span
                  >
                </div>
                <input
                  id="input-fecha-inicial2"
                  type="text"
                  class="datepicker center-align"
                  style="cursor: pointer;"
                />
              </div>

              <div class="col s6 m3 l2 input-date" style="cursor: pointer;">
                <link
                  rel="stylesheet"
                  href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
                />
                <div class="center-align" @click="dateFin">
                  <span
                    class="material-symbols-outlined btn-style "
                    style="position: relative; top: 4px;"
                    >event</span
                  >
                  <span
                    class="prefix"
                    style="font-size: 18px; width: 6rem; top: 0.2rem;"
                    >Fecha Final:</span
                  >
                </div>
                <input
                  id="input-fecha-final2"
                  type="text"
                  class="datepicker center-align"
                  style="cursor: pointer;"
                />
              </div>
            </div>

          </div>
          <div >
            <div class="col s6 left-align"></div>
            <div class="col s6 right-align">
              <div
                  class=" waves-effect waves-light btn tooltipped blue-grey darken-3"
                  @click="toggleFiltros"
                  data-position="top"
                  data-tooltip="Mostrar Filtros"
                  v-if="mostrarFiltros == false"
              >
                <link
                    rel="stylesheet"

                    href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
                />
                <span
                    class="material-symbols-outlined btn-style"

                >
                    filter_alt_off
                  </span>
              </div>
              <div
                  class=" waves-effect waves-light btn tooltipped blue-grey darken-3"
                  @click="toggleFiltros"
                  data-position="top"
                  data-tooltip="Ocultar Filtros"
                  v-if="mostrarFiltros == true"
              >
                <link
                    rel="stylesheet"

                    href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
                />
                <span
                    class="material-symbols-outlined btn-style"

                >
                    filter_alt
                  </span>
              </div>
              <div
                  class="waves-effect waves-light btn tooltipped blue-grey darken-3"
                  @click="generarExcel"
                  data-position="top"
                  data-tooltip="Generar Excel"
              >
                <i class="fa fa-file-excel-o " aria-hidden="true"></i>
              </div>
            </div>

            <div class="row" v-show="mostrarFiltros">
              <div
                  class="column col s6 m6 l2 xl2"
                  v-for="title in titles"
              >
                <div class="chips validate input-filtros" :id="title.key">
                  <input
                      class="chip-input"
                      :id="'input-' + title.key"
                      @focusout="handleFocusOut(title.key)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col s12 l10 offset-l1 card-panel" style="margin-bottom: 5rem">
        <div class="row">
          <div id="iccs" class="table-responsive ">
            <table class="striped highlight ">
              <thead>
                <tr>
                  <th v-for="title in titles">
                    {{ title.value }}
                  </th>
                  <th v-if="userLevel < 2">Editar</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in agregar100">
                  <td v-for="title in titles">
                    <div
                      class="input-field m-0"
                      v-show="title.isEditable && editableRow.icc === row.icc"
                    >
                      <input
                        :id="index + '-' + title.key"
                        type="text"
                        v-model="editableRow[title.key]"
                      />
                      <label :for="index + '-' + title.key">{{
                        title.value
                      }}</label>
                    </div>
                    <div
                      v-show="
                        !(title.isEditable && editableRow.icc === row.icc)
                      "
                      :class="title.key === 'icc' ? 'fs-08 truncate' : 'fs-09'"
                    >
                      <p v-if="title.key === 'portDate'">
                        <span v-if="row.portDate && row.isPort">
                          {{ row[title.key] }}
                        </span>
                      </p>
                      <p v-else>{{ row[title.key] }}</p>
                    </div>
                    <div
                      v-show="
                        title.key === 'rechargeDate' &&
                          ((!row.rechargeDate && !row.portDate) || !row.isPort)
                      "
                      class="fs-09"
                    >
                      Aun no se puede recargar
                    </div>
                    <div
                      v-show="
                        title.key === 'portDate' &&
                          !row.destinationDn &&
                          !editableRow.icc &&
                          !row.portDate
                      "
                      class="fs-09"
                    >
                      Aun no se puede Portar
                    </div>
                    <div
                      class=" waves-effect waves-light btn tooltipped blue-grey darken-3"
                      v-show="
                        title.key === 'destinationDn' &&
                          !row.destinationDn &&
                          !editableRow.icc
                      "
                      @click="activeIcc(row)"
                      :class="
                        'btn waves-effect waves-light light-blue darken-1 ' +
                          row.disable
                      "
                      data-position="top"
                      data-tooltip="Activar"
                    >
                      <link
                        rel="stylesheet"
                        href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0"
                      />
                      <span class="material-symbols-outlined btn-style">
                        <span class="material-symbols-outlined">
                          <span class="material-symbols-outlined">
                            mobile_friendly
                          </span>
                        </span>
                      </span>
                    </div>
                    <div
                        class=" waves-effect waves-light btn tooltipped blue-grey darken-3"
                        @click="port(row)"
                        v-show="
                        title.key === 'portDate' &&
                          !row.portDate &&
                          row.destinationDn
                      "
                        data-position="top"
                        data-tooltip="Portar"
                    >
                      <link
                          rel="stylesheet"
                          href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0"
                      />
                      <span class="material-symbols-outlined btn-style">
                        offline_share
                      </span>
                    </div>

                    <div
                      class=" waves-effect waves-light btn tooltipped blue-grey darken-3"
                      v-show="
                        title.key === 'portDate' && row.portDate && !row.isPort
                      "
                      @click="port(row)"
                      :class="
                        'btn waves-effect waves-light teal darken-1 ' +
                          row.disable
                      "
                      data-position="top"
                      data-tooltip="Portar nuevamente"
                    >
                      <link
                        rel="stylesheet"
                        href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0"
                      />
                      <span class="material-symbols-outlined btn-style">
                        offline_share
                      </span>
                    </div>

                    <div
                        class=" waves-effect waves-light btn tooltipped blue-grey darken-3"
                        v-if="
                        title.key === 'rechargeDate' &&
                          !row.rechargeDate &&
                          row.portDate &&
                          row.isPort &&
                          !editableRow.icc
                      "
                        @click="recharge(row)"
                        :class="
                        'btn waves-effect waves-light teal darken-1 ' +
                          row.disable
                      "
                        data-position="top"
                        data-tooltip="Recargar"
                    >
                      <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200" />
                      <span class="material-symbols-outlined btn-style">
                        open_in_phone
                      </span>
                    </div>
<!--                    <button-->
<!--                      v-if="-->
<!--                        title.key === 'rechargeDate' &&-->
<!--                          !row.rechargeDate &&-->
<!--                          row.portDate &&-->
<!--                          row.isPort &&-->
<!--                          !editableRow.icc-->
<!--                      "-->
<!--                      @click="recharge(row)"-->
<!--                      :class="-->
<!--                        'btn waves-effect waves-light green darken-2 ' +-->
<!--                          row.disable-->
<!--                      "-->
<!--                    >-->
<!--                      <div class="hide-on-small-only">Recargar</div>-->
<!--                      <i class="material-icons">arrow_upward</i>-->
<!--                    </button>-->
                    <div
                      class=" waves-effect waves-light btn tooltipped blue-grey darken-3"
                      v-if="
                        title.key === 'detail' &&
                          row.portDate &&
                          !editableRow.icc
                      "
                      @click="getDatail(row)"
                      :class="
                        'btn waves-effect waves-light  orange darken-3 ' +
                          row.disable
                      "
                      data-position="top"
                      data-tooltip="Detalles"
                    >
                    <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0" />
                      <span class="material-symbols-outlined btn-style">
                        breaking_news_alt_1
                      </span>
                    </div>
                    <input
                      type="text"
                      v-if="
                        title.key === 'rechargeDate' &&
                          !row.rechargeDate &&
                          row.portDate &&
                          row.icc === editableRow.icc
                      "
                      v-model="folio"
                    />

                    <button
                      v-if="
                        title.key === 'rechargeDate' &&
                          !row.rechargeDate &&
                          row.portDate &&
                          row.isPort &&
                          row.icc === editableRow.icc
                      "
                      @click="rechargeExternally(row)"
                      :class="
                        'btn waves-effect waves-light blue darken-2 ' +
                          row.disable
                      "
                    >
                      <div
                        class="hide-on-small-only"
                        style="font-size: 8px; width: 120px"
                      >
                        Recargar externamente
                      </div>
                      <i class="material-icons">arrow_upward</i>
                    </button>
                  </td>
                  <td class="center-align">
                    <i

                        data-position="top"
                        data-tooltip="Editar"
                        style="cursor: pointer"
                      v-show="userLevel < 2 && editableRow.icc !== row.icc"
                      class="fa fa-pencil-alt tooltipped"
                      @click="editMode(row)"
                      aria-hidden="true"
                    />
                    <i
                        data-position="top"
                        data-tooltip="Editar"
                        style="cursor: pointer"
                      v-show="row.icc === editableRow.icc"
                      class="fa fa-sync-alt fuenteVerde tooltipped"
                      @click="updateIcc(row)"
                      aria-hidden="true"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import {
  portOutsList,
  updatePortOut,
  updateActive,
  recharge,
  rechargeExternally,
  getDetailPorOut,
} from "@/api/portOuts";
import { creaExcel, getIccs, recargaExterna } from "@/api/api";
import { i18n } from "@/constantes";
import { mapState } from "vuex";

let filtros = {};

export default {
  name: "portabilidades",
  data() {
    return {
      titles: [
        { key: "icc", value: "Icc", isEditable: false },
        { key: "leaderName", value: "Lider", isEditable: true },
        { key: "clientName", value: "Cliente", isEditable: true },
        { key: "inter", value: "Interconexion", isEditable: true },
        { key: "insertedDate", value: "Fecha de subida", isEditable: false },
        { key: "username", value: "Subido por", isEditable: false },
        { key: "rechargeAmount", value: "Monto", isEditable: true },
        { key: "nip", value: "Nip", isEditable: true },
        { key: "originCarrier", value: "Compañia origen", isEditable: true },
        {
          key: "destinationCarrier",
          value: "Compañia destino",
          isEditable: true,
        },
        { key: "originDn", value: "Dn origen", isEditable: true },
        { key: "destinationDn", value: "Dn destino", isEditable: true },
        { key: "portDate", value: "Fecha portabilidad", isEditable: false },
        { key: "rechargeDate", value: "Fecha recarga", isEditable: false },
        { key: "detail", value: "Detalle", isEditable: false },
      ],
      rows: [],
      editableRow: {},
      userLevel: 1,
      cuerpos: [],
      filteredRows: [],
      titulo: "",
      folio: "",
      rowDetail: null,
      detail: null,
      chips: [],
      chipsOptions: {
        onChipAdd: this.addChip,
        onChipDelete: this.deleteChip,
      },
      mostrarFiltros: true,
      datosRecibios: [],
      datosAMostrar: [],
      indexScroll: 1,
    };
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        M.AutoInit();
        this.initChips();
        M.Datepicker.init(document.querySelectorAll(".datepicker"), {
          format: "yyyy/mm/dd",
          i18n: i18n,
          onClose: () => {
            this.getIccs();
          },
        });

        const dateI = new Date();
        const dia = dateI.getDate() > 27 ? 27 : dateI.getDate();
        const mes =
            dateI.getMonth() == 0
                ? 11
                : dateI.getMonth() == 1
                ? 12
                : dateI.getMonth() - 1;
        const anio =
            dateI.getMonth() == 0 || dateI.getMonth() == 1
                ? dateI.getFullYear() - 1
                : dateI.getFullYear();
        const fechaIni = `${anio}/${mes}/${dia}`;
        if (!window.location.href.includes("recargasasec.com"))
          document.getElementById("input-fecha-inicial2").value = fechaIni;
        const dateF = new Date(Date.now());
        const fechaFin = `${dateF.getFullYear()}/${dateF.getMonth() +
        1}/${dateF.getDate()}`;
        if (!window.location.href.includes("recargasasec.com"))
          document.getElementById("input-fecha-final2").value = fechaFin;

        this.getIccs();
        $(window).scroll(() => {
          if ($(document).height() < $(window).scrollTop() + $(window).height() + 100) {
            this.indexScroll++;
            setTimeout(() => {
              var elems = document.querySelectorAll(".tooltipped");
              M.Tooltip.init(elems)
            }, 1);
          }
        })
      },1000)
    })
  },

  methods: {
    toggleFiltros() {
      this.mostrarFiltros = !this.mostrarFiltros;
    },
    handleFocusOut(llave) {
      const inputId = "input-" + llave;
      const input = document.getElementById(inputId);
      input.dispatchEvent(
        new KeyboardEvent("keydown", {
          key: "Enter",
          code: "Enter",
          keyCode: 13,
          which: 13,
        })
      );
    },
    initChips() {
      this.titles.forEach((title) => {
        const elems = document.getElementById(title.key);
        const chipsOptions = {
          ...this.chipsOptions,
          key: title.key,
          placeholder: `${title.value}`,
        };
        const chip = M.Chips.init(elems, chipsOptions);
      });
    },
    deleteChip(a, b) {
      const key = a[0].M_Chips.options.key;
      const value = b.firstChild.textContent;
      this.chips = this.chips.filter(
        (c) => !(c.key === key && c.value === value)
      );
      console.log(this.chips);
    },
    addChip(a, b) {
      const key = a[0].M_Chips.options.key;
      const value = b.firstChild.textContent;
      this.chips.push({ key, value });
      console.log(this.chips);
    },
    dateIni() {
      const elem = document.getElementById("input-fecha-inicial2");
      const instance = M.Datepicker.getInstance(elem);
      instance.open();
      console.log("wea");
    },
    dateFin() {
      const elem = document.getElementById("input-fecha-final2");
      const instance = M.Datepicker.getInstance(elem);
      instance.open();
    },
    generarExcel() {
      console.log("por generar excel loco");
      this.$store.commit("ponerBarra");

      let fechaIni = document
        .getElementById("input-fecha-inicial2")
        .value.trim();
      let fechaFin = document.getElementById("input-fecha-final2").value.trim();
      let diaIni, mesIni, anioIni, diaFin, mesFin, anioFin;
      if (fechaIni.length > 2) {
        const fechaSeparada = fechaIni.split("/");
        diaIni = fechaSeparada[2];
        mesIni = fechaSeparada[1];
        anioIni = fechaSeparada[0];
      }
      if (fechaFin.length > 2) {
        const fechaSeparada = fechaFin.split("/");
        diaFin = fechaSeparada[2];
        mesFin = fechaSeparada[1];
        anioFin = fechaSeparada[0];
      }
      const fechas = {
        diaIni,
        mesIni,
        anioIni,
        diaFin,
        mesFin,
        anioFin,
      };
      console.log(`1132312321`);
      creaExcel(filtros, "PORTAS", fechas)
        .then((response) => {
          this.$store.commit("quitarBarra");
          if (window.location.href.includes("recargasasec.com")) {
            console.log(process.env.NODE_ENV);

            window.location =
              process.env.NODE_ENV == "productionCam"
                ? `https://recargasasec.com/excel?nombre=${response.data.nombreArchivo}`
                : `http://localhost:8091/excel?nombre=${response.data.nombreArchivo}`;
          } else {
            window.location =
              process.env.NODE_ENV === "production"
                ? `https://recarga-te.com/excel?nombre=${response.data.nombreArchivo}`
                : `http://localhost:8091/excel?nombre=${response.data.nombreArchivo}`;
          }
        })
        .catch((error) => {
          this.$store.commit("quitarBarra");
          console.log(error);
          M.toast({
            html: "No se pudo crear el excel",
            classes: "rounded",
            displayLength: 3000,
          });
        });
    },
    activeIcc(row) {
      this.modify = {};
      this.modify.portDate = "true";
      this.modify.id = row.id;
      const data = {
        ...row,
        origin: `web`,
      };
      updateActive({ $store: this.$store, data })
        .then((response) => {
          this.getIccs();
          return M.toast({
            html: `Icc activado corretamente`,
            classes: "rounded",
            displayLength: 5000,
          });
        })
        .catch((error) => {
          return M.toast({
            html: error,
            classes: "rounded",
            displayLength: 5000,
          });
        });
    },
    getIccs() {
      this.encontrados = "Cargando ...";
      filtros = {};
      this.datosAMostrar = [];
      this.datosRecibios = [];
      this.movimientos = [];
      let fechaIni = document
        .getElementById("input-fecha-inicial2")
        .value.trim();
      let fechaFin = document.getElementById("input-fecha-final2").value.trim();

      let diaIni, mesIni, anioIni, diaFin, mesFin, anioFin;
      if (fechaIni.length > 2) {
        const fechaSeparada = fechaIni.split("/");
        diaIni = fechaSeparada[2];
        mesIni = fechaSeparada[1];
        anioIni = fechaSeparada[0];
      }
      if (fechaFin.length > 2) {
        const fechaSeparada = fechaFin.split("/");
        diaFin = fechaSeparada[2];
        mesFin = fechaSeparada[1];
        anioFin = fechaSeparada[0];
      }

      const data = {
        diaIni,
        mesIni,
        anioIni,
        diaFin,
        mesFin,
        anioFin,
      };

      portOutsList(this, data)
        .then((response) => {
          response.rows = response.rows.map((r) => {
            return {
              id: r.id,
              leaderName: r.leaderName,
              clientName: r.clientName,
              insertedDate: r.insertedDate,
              username: r.username,
              destinationDn: r.destinationDn ? `${r.destinationDn}` : null,
              originCarrier: r.originCarrier ? r.originCarrier : `NA`,
              icc: r.icc,
              originDn: r.originDn ? `${r.originDn}` : `NA`,
              destinationCarrier: r.destinationCarrier,
              portDate: r.portDate,
              rechargeDate: r.rechargeDate,
              rechargeAmount: r.rechargeAmount ? r.rechargeAmount : `NA`,
              nip: r.nip ? r.nip : `NA`,
              inter: r.inter ? r.inter : `NA`,
              isPort: r.isPort ? r.isPort : 0,
            };
          });
          this.datosRecibios = this.datosRecibios.concat(response.rows.slice());
          this.datosAMostrar = this.datosAMostrar.concat(response.rows.slice());
          this.numeroDeFilas = this.datosRecibios.length;
          this.encontrados = `${this.datosAMostrar.length} encontrados`;
          this.$nextTick(() => {
            M.updateTextFields();
            setTimeout(() => {
              var elems = document.querySelectorAll(".tooltipped");
              var instances = M.Tooltip.init(elems);
              console.log(instances);
            }, 1000);
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    editMode(row) {
      row = {
        id: row.id,
        leaderName: row.leaderName,
        clientName: row.clientName,
        destinationDn: row.destinationDn ? `${row.destinationDn}` : null,
        originCarrier: row.originCarrier != `NA` ? row.originCarrier : ``,
        icc: row.icc,
        originDn: row.originDn != `NA` ? `${row.originDn}` : ``,
        destinationCarrier: row.destinationCarrier,
        portDate: row.portDate,
        rechargeDate: row.rechargeDate,
        rechargeAmount: row.rechargeAmount != `NA` ? row.rechargeAmount : ``,
        nip: row.nip != `NA` ? row.nip : ``,
        inter: row.inter != `NA` ? row.inter : ``,
      };
      this.editableRow = JSON.parse(JSON.stringify(row));
      this.$nextTick(() => M.updateTextFields());
    },
    getDatail(row) {
      this.rowDetail = row;
      this.detail = null;
      M.Modal.getInstance(document.getElementById(`modal1`)).open();
      getDetailPorOut({ $store: this.$store, dn: row.originDn })
        .then((resp) => {
          this.detail = resp.data;
        })
        .catch((error) => {
          console.log(error);
          M.Modal.getInstance(document.getElementById(`modal1`)).close();
          return M.toast({
            html: "No fue posible obtener el detalle.",
            classes: "rounded",
            displayLength: 5000,
          });
        });
    },
    updateIcc(row) {
      console.log(row.rechargeAmount != `NA`);
      this.modify = {};
      row = {
        id: row.id,
        leaderName: row.leaderName,
        clientName: row.clientName,
        destinationDn: row.destinationDn ? `${row.destinationDn}` : null,
        originCarrier: row.originCarrier != `NA` ? row.originCarrier : ``,
        icc: row.icc,
        originDn: row.originDn != `NA` ? `${row.originDn}` : ``,
        destinationCarrier: row.destinationCarrier,
        portDate: row.portDate,
        rechargeDate: row.rechargeDate,
        rechargeAmount: row.rechargeAmount != `NA` ? row.rechargeAmount : ``,
        nip: row.nip != `NA` ? row.nip : ``,
        inter: row.inter != `NA` ? row.inter : ``,
      };
      if (JSON.stringify(row) === JSON.stringify(this.editableRow)) {
        this.editableRow = {};
        return M.toast({
          html: "Ningun cambio para actualizar",
          classes: "rounded",
          displayLength: 5000,
        });
      }

      this.modify.id = row.id;

      if (row.leaderName !== this.editableRow.leaderName)
        this.modify.leaderName = this.editableRow.leaderName;
      if (row.rechargeAmount !== this.editableRow.rechargeAmount)
        this.modify.rechargeAmount = this.editableRow.rechargeAmount;
      if (row.clientName !== this.editableRow.clientName)
        this.modify.clientName = this.editableRow.clientName;
      if (row.originDn !== this.editableRow.originDn)
        this.modify.originDn = this.editableRow.originDn;
      if (row.originCarrier !== this.editableRow.originCarrier)
        this.modify.originCarrier = this.editableRow.originCarrier;
      if (row.destinationDn !== this.editableRow.destinationDn)
        this.modify.destinationDn = this.editableRow.destinationDn;
      if (row.destinationCarrier !== this.editableRow.destinationCarrier)
        this.modify.destinationCarrier = this.editableRow.destinationCarrier;
      if (row.nip !== this.editableRow.nip)
        this.modify.nip = this.editableRow.nip;
      console.log(this);
      updatePortOut(this)
        .then((e) => {
          this.editableRow = {};
          this.getIccs();
        })
        .catch((error) => {
          console.log(error);
          return M.toast({
            html: "No fue posible actualizar.",
            classes: "rounded",
            displayLength: 5000,
          });
        });
    },
    port(row) {
      row = {
        id: row.id,
        leaderName: row.leaderName,
        clientName: row.clientName,
        destinationDn: `${row.destinationDn}`,
        originCarrier: row.originCarrier != `NA` ? row.originCarrier : ``,
        icc: row.icc,
        originDn: row.originDn != `NA` ? `${row.originDn}` : ``,
        destinationCarrier: row.destinationCarrier,
        portDate: row.portDate,
        rechargeDate: row.rechargeDate,
        rechargeAmount: row.rechargeAmount != `NA` ? row.rechargeAmount : ``,
        nip: row.nip != `NA` ? row.nip : ``,
        inter: row.inter != `NA` ? row.inter : ``,
      };
      this.modify = {};
      this.modify = row;
      this.modify.portDate = "true";
      updatePortOut(this)
        .then((response) => {
          this.getIccs();
          return M.toast({
            html: `Icc Portado correctamente`,
            classes: "rounded",
            displayLength: 5000,
          });
        })
        .catch((error) => {
          return M.toast({
            html: error,
            classes: "rounded",
            displayLength: 5000,
          });
        });
    },
    recharge(row) {
      if (
        row.destinationDn === null ||
        row.rechargeAmount === null ||
        row.destinationCarrier === null
      )
        return M.toast({
          html: `No fue posible realizar la recarga, faltan datos`,
          classes: "rounded",
          displayLength: 5000,
        });

      this.id = row.id;
      recharge(this)
        .then((r) => {
          M.toast({
            html: "Recarga realizada con éxito",
            classes: "rounded",
            displayLength: 5000,
          });
          this.getIccs();
        })
        .catch((e) => {
          console.log(e);
          return M.toast({
            html: `No fue posible realizar la recarga ${e}`,
            classes: "rounded",
            displayLength: 5000,
          });
        });
    },
    rechargeExternally(row) {
      this.id = row.id;
      this.type = 3;
      if (
        row.destinationDn === null ||
        row.rechargeAmount === null ||
        row.destinationCarrier === null
      )
        return M.toast({
          html: `No fue posible realizar la recarga, faltan datos`,
          classes: "rounded",
          displayLength: 5000,
        });
      if (this.folio === "")
        return M.toast({
          html: "No se recibió folio para recarga externa",
          classes: "rounded",
          displayLength: 5000,
        });
      let objetoaEnviar = {};
      objetoaEnviar.icc = row.icc;
      objetoaEnviar.dn = this.telefono;
      objetoaEnviar.folio = this.folio;
      objetoaEnviar.type = 3;
      objetoaEnviar.id = row.id;
      return recargaExterna(
        objetoaEnviar,
        this.companiaSeleccionada,
        this.montoSeleccionado,
        this.tipoPeticion
      )
        .then((r) => {
          return rechargeExternally(this);
        })
        .then((r) => {
          M.toast({
            html: "Recarga externa asignada con éxito",
            classes: "rounded",
            displayLength: 5000,
          });
          this.editableRow = {};
          return this.getIccs();
        })
        .catch((e) => {
          console.log(e);
          return M.toast({
            html: `No fue posible realizar la recarga ${e}`,
            classes: "rounded",
            displayLength: 5000,
          });
        });
    },
    filter(event) {
      filtros[event.target.id] = event.target.value;
      let auxArray = this.cuerpos.slice().concat(this.rows);
      this.cuerpos = [];
      this.$nextTick(() => M.updateTextFields());
      console.log(event.inputType);
      if (event.inputType === "deleteContentBackward") {
        this.filteredRows = this.rows.slice();

        this.titles.forEach((title) => {
          console.log(title);
          const llave = title.key;
          const auxFiltro = filtros[llave];
          console.log(title, llave, auxFiltro, filtros);
          if (auxFiltro && auxFiltro !== "") {
            this.filteredRows = this.rows.filter((fila) => {
              //console.log(fila, llave, fila[llave], fila[llave] != null)
              return fila[llave] ? fila[llave].includes(auxFiltro) : false;
            });
          }
        });
        console.log(
          this.filteredRows,
          `el final
        `
        );
      } else {
        console.log(event.target.id);

        this.filteredRows = this.rows.filter((fila) => {
          //console.log(fila, fila[event.target.id], fila[event.target.id] != null)
          return fila[event.target.id]
            ? fila[event.target.id].includes(event.target.value)
            : false;
        });

        console.log(this.filteredRows);
      }
      this.titulo = `${this.filteredRows.length} encontrados`;
      this.agregar100();
    },
  },
  computed: {
    ...mapState(["isAdmin"]),
    computedList() {
      this.datosAMostrar = this.datosRecibios.slice();
      console.log(this.titulo);
      if (this.chips.length) {
        let auxChips = this.chips.slice();
        let chipsArray = [];
        while (auxChips.length) {
          let chip = auxChips[0];
          chipsArray.push(
            auxChips.filter((auxChip) => auxChip.key == chip.key)
          );
          auxChips = auxChips.filter((auxChip) => auxChip.key != chip.key);
        }
        let auxDatosAMostrar = this.datosAMostrar.slice();
        chipsArray.forEach((element) => {
          auxDatosAMostrar = auxDatosAMostrar.filter((item) => {
            return element.some((titulo) => {
              return item[titulo.key]
                .toUpperCase()
                .includes(titulo.value.toUpperCase());
            });
          });
        });
        this.datosAMostrar = auxDatosAMostrar;
        console.log("Termino");
        console.log(this.datosAMostrar.length);
      }
      return this.datosAMostrar;
    },
    agregar100() {
      return this.computedList.slice(0, 20 * this.indexScroll);
    },
  },
};
</script>

<style scoped>
.chips .input {
  display: block;
}
.col .row {
  margin-left: -0rem;
  margin-right: -0rem;
}
.page-title {
  font-weight: inherit;
  font-size: 24px;
  margin-top: auto;
  margin-bottom: auto;
  list-style-type: none;
  display: inline-block;
  padding: 0.75rem 0 1rem;
  color: rgba(0, 0, 0, 0.623);
  -webkit-animation: focus-in-contract 2.1s cubic-bezier(0.25, 0.46, 0.45, 0.94)
    both;
  animation: focus-in-contract 2.1s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}
@-webkit-keyframes focus-in-contract {
  0% {
    letter-spacing: 1em;
    -webkit-filter: blur(12px);
    filter: blur(12px);
    opacity: 0;
  }
  100% {
    -webkit-filter: blur(0px);
    filter: blur(0px);
    opacity: 1;
  }
}
@keyframes focus-in-contract {
  0% {
    letter-spacing: 1em;
    -webkit-filter: blur(12px);
    filter: blur(12px);
    opacity: 0;
  }
  100% {
    -webkit-filter: blur(0px);
    filter: blur(0px);
    opacity: 1;
  }
}
.card-panel {
  border-radius: 10px;
  padding-top: 15px;
  padding-bottom: 15px;
  overflow: auto;
}
table {
  font-size: 0.9rem;
}
.table-responsive {
  display: block;
  overflow-x: auto;
  width: 100%;
  text-align-last: center;
}
.icc-table {
  font-size: 0.75rem;
}

td {
  padding: 8px 3px;
}

@media (max-width: 800px) {
  table {
    font-size: 0.8rem;
  }
  .icc-table {
    font-size: 0.6rem;
  }
  .titulo {
    font-size: 2rem;
  }
}

/*.input-field > label {*/
/*  font-size: 0.75rem;*/
/*}*/

.row{
  padding: 1rem;
}

.main-container {
  width: 94%;
  margin: 0 auto;
}

.fuenteVerde {
  color: #00b134;
}

.fa {
  font-size: 1.2em;
}

.fa-pencil-alt {
  color: #084c63;
}

.btn {
  width: 70px;
  text-align-last: center;
}
.btn-style {
  margin-top: 5px;
}

td {
  padding: 12px 3px;
}

.icon-button {
  font-size: 0.9rem;
}

.fixed-action-btn {
  top: 80px;
  height: 100px;
}

.datepicker {
  border-bottom: none !important;
}

.input-date {
  margin: 0.7rem 0 0 0;
}
</style>
